import { WaiterWith } from "common/promises";
export class Param {
    constructor() {
        this.waiter = new WaiterWith();
    }
    fill({ videoElem, progressElem, }) {
        this.waiter.trigger({
            videoElem,
            progressElem,
        });
    }
}
//# sourceMappingURL=common.js.map